import { Button, Chip, Divider, Grid, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ReactHtmlParser from "react-html-parser";
import BusinessContactUs from "./BusinessContactUs";
import { Link } from "react-router-dom";
import BusinessRegions from "views/Business/components/BusinessRegions";
import BusinessContactEditView from "views/Business/MyBusiness/BusinessContactEditView";

function BusinessProfileAbout({
  PublicProfile,
  permissions,
  isEditView,
  profile,
  IsSearchPublicProfile,
  isMobileView = false,
}) {
  const businessProfile = profile?.businessProfile;
  const businessRegions = profile?.regions;
  const descriptionHeightRef = useRef(null);
  const statesOfIndia = [
    { stateName: "Andhra Pradesh", stateCode: "AP", value: false },
    { stateName: "Arunachal Pradesh", stateCode: "AR", value: false },
    { stateName: "Assam", stateCode: "AS", value: false },
    { stateName: "Bihar", stateCode: "BR", value: false },
    { stateName: "Chhattisgarh", stateCode: "CG", value: false },
    { stateName: "Goa", stateCode: "GA", value: false },
    { stateName: "Gujarat", stateCode: "GJ", value: false },
    { stateName: "Haryana", stateCode: "HR", value: false },
    { stateName: "Himachal Pradesh", stateCode: "HP", value: false },
    { stateName: "Jharkhand", stateCode: "JH", value: false },
    { stateName: "Karnataka", stateCode: "KA", value: false },
    { stateName: "Kerala", stateCode: "KL", value: false },
    { stateName: "Madhya Pradesh", stateCode: "MP", value: false },
    { stateName: "Maharashtra", stateCode: "MH", value: false },
    { stateName: "Manipur", stateCode: "MN", value: false },
    { stateName: "Meghalaya", stateCode: "ML", value: false },
    { stateName: "Mizoram", stateCode: "MZ", value: false },
    { stateName: "Nagaland", stateCode: "NL", value: false },
    { stateName: "Odisha", stateCode: "OR", value: false },
    { stateName: "Punjab", stateCode: "PB", value: false },
    { stateName: "Rajasthan", stateCode: "RJ", value: false },
    { stateName: "Sikkim", stateCode: "SK", value: false },
    { stateName: "Tamil Nadu", stateCode: "TN", value: false },
    { stateName: "Telangana", stateCode: "TG", value: false },
    { stateName: "Tripura", stateCode: "TR", value: false },
    { stateName: "Uttar Pradesh", stateCode: "UP", value: false },
    { stateName: "Uttarakhand", stateCode: "UK", value: false },
    { stateName: "West Bengal", stateCode: "WB", value: false },
    { stateName: "Andaman and Nicobar Islands", stateCode: "AN", value: false },
    { stateName: "Chandigarh", stateCode: "CH", value: false },
    {
      stateName: "Dadra and Nagar Haveli and Daman and Diu",
      stateCode: "DNDD",
      value: false,
    },
    { stateName: "Delhi", stateCode: "DL", value: false },
    { stateName: "Ladakh", stateCode: "LA", value: false },
    { stateName: "Lakshadweep", stateCode: "LD", value: false },
    { stateName: "Puducherry", stateCode: "PY", value: false },
    { stateName: "Jammu and Kashmir", stateCode: "JK", value: false },
  ];
  const [regionModel, setRegionModel] = useState(false);
  const [apiDistricts, setApiDistricts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [checkedStates, setCheckedStates] = useState(statesOfIndia);
  const preSelectedStates = businessRegions?.state ?? [];
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [showReadmore, setShowReadmore] = useState(false);
  const [descriptionHeight, setDescriptionHeight] = useState("auto");

  const description = businessProfile?.description;
  const regionState = businessRegions?.state || [];
  const regionSelectedCities = businessRegions?.Selectedcities || [];
  const region = [...regionState, ...regionSelectedCities];
  const replacedOlString = description?.replaceAll(
    "<ol>",
    '<ol style="padding-left: 34px; list-style-type: decimal">'
  );
  // Replace <ul> with style attribute
  const replacedString = replacedOlString?.replaceAll(
    "<ul>",
    '<ul style="padding-left: 34px; list-style-type: disc">'
  );

  const handleAddRegions = () => {
    if (permissions?.isUpdateAllowed) {
      if (permissions?.isOwner) {
        setRegionModel(true);
      } else {
      }
    } else {
      setRegionModel(true);
    }
    setCheckedStates((prevCheckedStates) =>
      prevCheckedStates.map((state) => {
        if (preSelectedStates.includes(state.stateName)) {
          return {
            ...state,
            value: true,
            stateCode: state.stateCode,
          };
        }
        return state;
      })
    );

    setDistricts(
      apiDistricts
        .filter((data) => !preSelectedStates.includes(data.state))
        .map((obj) => obj.districts)
        .flat()
    );
  };
  const toggleDescription = () => {
    setShowFullDescription(!showFullDescription);
    setDescriptionHeight(!showFullDescription ? "auto" : "191px");
  };

  const desc = replacedString || "";
  const displayedDescription = showFullDescription ? desc : desc.slice(0, 350); // Adjust the character limit as needed
  useEffect(() => {
    setDescriptionHeight("auto"); // to display read more and read less to update descriptionHeight when data is change
    setTimeout(() => {
      if (descriptionHeightRef?.current) {
        const componentHeight =
          descriptionHeightRef.current.getBoundingClientRect().height;
        setShowReadmore(componentHeight > 190);
        if (componentHeight > 191) setDescriptionHeight("191px");
      }
    }, [100]);
    setShowFullDescription(false);
  }, [businessProfile]);
  return (
    <Grid
      sx={{ marginLeft: "46px", paddingX: IsSearchPublicProfile ? "26px" : "" }}
    >
      <Grid>
        <Typography
          sx={{ fontSize: "18px", fontWeight: "600", marginTop: "18px" }}
        >
          What you should know about {profile?.businessName}
        </Typography>
      </Grid>
      <Grid
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginRight: "28px",
          paddingBottom: "35px",
          paddingTop: "20px",
        }}
      >
        <Grid sx={{ paddingRight: "46px" }}>
          <Grid>
            <Typography
              sx={{ fontSize: "14px", fontWeight: 600, marginBottom: "5px" }}
            >
              {businessProfile?.businessHeadline}
            </Typography>
            <Typography
            dangerouslySetInnerHTML={{ __html: desc }}
              ref={descriptionHeightRef}
              sx={{
                fontSize: "14px",
                height: descriptionHeight,
                overflow: "hidden",
              }}
           />
              {/* {ReactHtmlParser(desc)}
            </Typography> */}
            {showReadmore && (
              <span
                style={{
                  color: "#2864BE",
                  textDecoration: "underline",
                  fontSize: "14px",
                  cursor: "pointer",
                }}
                onClick={toggleDescription}
              >
                {" "}
                {showFullDescription ? "Read Less" : "Read More"}
              </span>
            )}
          </Grid>
        </Grid>

        {!isMobileView && (
          <Grid>
            {" "}
            {isEditView ? (
              <BusinessContactEditView
                profile={profile}
                PublicProfile={PublicProfile}
                permissions={permissions}
                isEditView={isEditView}
              />
            ) : (
              <BusinessContactUs
                profile={profile}
                PublicProfile={PublicProfile}
                permissions={permissions}
                isEditView={isEditView}
              />
            )}
          </Grid>
        )}
      </Grid>

      <Grid sx={{ marginTop: "20px" }}>
        <Typography
          style={{
            fontSize: "16px",
            fontWeight: "600",
            lineHeight: "20px",
            marginBottom: "10px",
          }}
        >
          Region Served
        </Typography>
        {!isEditView ? (
          <Grid>
            {regionState?.length == 36 ? (
              <Chip
                label={"All Over India"}
                variant="outlined"
                size="small"
                style={{ marginRight: "10px", marginBottom: "6px" }}
              />
            ) : region && region?.length > 0 ? (
              region?.map((item) => (
                <Chip
                  label={item}
                  variant="outlined"
                  size="small"
                  style={{ marginRight: "10px", marginBottom: "6px" }}
                />
              ))
            ) : (
              <Typography
                style={{
                  fontSize: "14px",
                  lineHeight: "20px",
                  width: "383px",
                  marginTop: "8px",
                  marginBottom: "29px",
                }}
              >
                Not Disclosed
              </Typography>
            )}
          </Grid>
        ) : (
          <BusinessRegions
            supplierId={profile?.supplierId}
            services={profile?.services}
            PublicProfile={PublicProfile}
            permissions={permissions}
            businessRegions={profile?.regions}
          />
        )}
      </Grid>
    </Grid>
  );
}

export default BusinessProfileAbout;
